import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://readdy.ai/api/search-image?query=african%20person%20happily%20using%20smartphone%20browsing%20internet%20with%20data%20connection%20modern%20clean%20gradient%20background%20yellow%20gold%20navy%20blue%20tones%20professional%20photography%20showing%20mobile%20data%20connectivity%20and%20digital%20lifestyle&width=1400&height=800&seq=hero-data-slide-brand-001&orientation=landscape",
      title: "Lightning-Fast Data Bundles",
      description: "Stay connected with affordable data plans for all networks. Get instant delivery and enjoy seamless browsing, streaming, and downloads.",
      cta: "Buy Data Now"
    },
    {
      image: "https://readdy.ai/api/search-image?query=african%20person%20making%20phone%20call%20smiling%20with%20smartphone%20modern%20clean%20gradient%20background%20yellow%20gold%20navy%20blue%20tones%20professional%20photography%20showing%20mobile%20airtime%20recharge%20and%20communication%20convenience&width=1400&height=800&seq=hero-airtime-slide-brand-002&orientation=landscape",
      title: "Instant Airtime Recharge",
      description: "Top up your phone in seconds. Support for MTN, Airtel, Glo, and 9mobile. Never run out of airtime with our quick and reliable service.",
      cta: "Recharge Airtime"
    },
    {
      image: "https://readdy.ai/api/search-image?query=african%20home%20with%20modern%20lighting%20and%20electrical%20appliances%20happy%20family%20using%20electricity%20modern%20clean%20gradient%20background%20yellow%20gold%20navy%20blue%20tones%20professional%20photography%20showing%20electricity%20bill%20payment%20and%20power%20convenience&width=1400&height=800&seq=hero-electricity-slide-brand-003&orientation=landscape",
      title: "Easy Electricity Bill Payments",
      description: "Pay your electricity bills instantly for all DISCOs across Nigeria. Keep your lights on with our fast and secure payment system.",
      cta: "Pay Bills Now"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img 
                src="./logo.png" 
                alt="IMAM BICHI DATA SUB Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <a href="#services" className="text-sm font-medium text-gray-700 hover:text-[#1e3a8a] transition-colors whitespace-nowrap cursor-pointer">Services</a>
              <a href="#how-it-works" className="text-sm font-medium text-gray-700 hover:text-[#1e3a8a] transition-colors whitespace-nowrap cursor-pointer">How It Works</a>
              <Link to="/contact" className="text-sm font-medium text-gray-700 hover:text-[#1e3a8a] transition-colors whitespace-nowrap cursor-pointer">Contact</Link>
              <button className="px-5 py-2.5 text-sm font-medium text-[#1e3a8a] border-2 border-[#1e3a8a] rounded-lg hover:bg-[#1e3a8a] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                Login
              </button>
              <button className="px-5 py-2.5 text-sm font-medium text-white bg-[#fbbf24] rounded-lg hover:bg-[#f59e0b] transition-colors whitespace-nowrap cursor-pointer">
                Register
              </button>
            </div>

            <button 
              className="md:hidden p-2 cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100">
            <div className="px-4 py-4 space-y-3">
              <a href="#services" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Services</a>
              <a href="#how-it-works" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">How It Works</a>
              <Link to="/contact" className="block text-sm font-medium text-gray-700 py-2 cursor-pointer">Contact</Link>
              <button className="w-full px-5 py-2.5 text-sm font-medium text-[#1e3a8a] border-2 border-[#1e3a8a] rounded-lg hover:bg-[#1e3a8a] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                Login
              </button>
              <button className="w-full px-5 py-2.5 text-sm font-medium text-white bg-[#fbbf24] rounded-lg hover:bg-[#f59e0b] transition-colors whitespace-nowrap cursor-pointer">
                Register
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section with Slider */}
      <section className="relative pt-20 pb-0 overflow-hidden h-screen">
        {/* Slides */}
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {/* Background Image */}
            <div className="absolute inset-0">
              <div className="w-full h-full">
                <img 
                  src={slide.image}
                  alt={slide.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-b from-[#1e3a8a]/60 via-[#1e3a8a]/50 to-black/60"></div>
            </div>

            {/* Content */}
            <div className="relative z-10 h-full flex items-center px-4 sm:px-6 lg:px-8">
              <div className="max-w-7xl mx-auto w-full">
                <div className="max-w-3xl">
                  <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-fade-in">
                    {slide.title}
                  </h1>
                  <p className="text-lg sm:text-xl text-white/90 mb-8 leading-relaxed animate-fade-in-delay">
                    {slide.description}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-delay-2">
                    <button className="px-8 py-4 text-base font-semibold text-[#1e3a8a] bg-[#fbbf24] rounded-lg hover:bg-[#f59e0b] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
                      {slide.cta}
                    </button>
                    <button className="px-8 py-4 text-base font-semibold text-white bg-white/10 backdrop-blur-sm border-2 border-white rounded-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-3">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                index === currentSlide 
                  ? 'bg-[#fbbf24] w-8' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 z-20 w-12 h-12 bg-white/10 backdrop-blur-sm border border-white/30 rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer"
          aria-label="Previous slide"
        >
          <i className="ri-arrow-left-s-line text-2xl text-white"></i>
        </button>
        <button
          onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 z-20 w-12 h-12 bg-white/10 backdrop-blur-sm border border-white/30 rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer"
          aria-label="Next slide"
        >
          <i className="ri-arrow-right-s-line text-2xl text-white"></i>
        </button>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
              Why Choose IMAM BICHI DATA SUB
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We provide the most reliable and affordable VTU services in Nigeria
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-[#fef3c7] p-8 rounded-xl hover:shadow-lg transition-shadow border border-[#fbbf24]/20">
              <div className="w-14 h-14 bg-[#fbbf24] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-flashlight-line text-2xl text-[#1e3a8a]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Fast Transactions</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Get instant delivery of airtime, data, and bill payments within seconds. No delays, no hassles.
              </p>
            </div>
            <div className="bg-[#dbeafe] p-8 rounded-xl hover:shadow-lg transition-shadow border border-[#1e3a8a]/20">
              <div className="w-14 h-14 bg-[#1e3a8a] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-price-tag-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Affordable Pricing</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Enjoy the best rates in the market. Save more on every transaction with our competitive prices.
              </p>
            </div>
            <div className="bg-[#fef3c7] p-8 rounded-xl hover:shadow-lg transition-shadow border border-[#fbbf24]/20">
              <div className="w-14 h-14 bg-[#fbbf24] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-2xl text-[#1e3a8a]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Secure Payments</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Your transactions are protected with bank-level security. Pay with confidence every time.
              </p>
            </div>
            <div className="bg-[#dbeafe] p-8 rounded-xl hover:shadow-lg transition-shadow border border-[#1e3a8a]/20">
              <div className="w-14 h-14 bg-[#1e3a8a] rounded-lg flex items-center justify-center mb-6">
                <i className="ri-24-hours-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">24/7 Availability</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Access our services anytime, anywhere. We're always here when you need us, day or night.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Your Trust is Our Priority Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
              Your Trust is Our Priority
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We're committed to providing secure, reliable, and transparent services you can count on
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl border-2 border-[#fbbf24]/30 hover:border-[#fbbf24] hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Bank-Level Security</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Your data and transactions are protected with advanced encryption and security protocols. We never compromise on your safety.
              </p>
              <div className="flex items-center gap-2 text-[#1e3a8a] text-sm font-medium">
                <i className="ri-checkbox-circle-line"></i>
                <span>SSL Encrypted</span>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl border-2 border-[#1e3a8a]/30 hover:border-[#1e3a8a] hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-verified-badge-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Licensed & Verified</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                We operate with full compliance to Nigerian regulations and are verified by all major network providers and service partners.
              </p>
              <div className="flex items-center gap-2 text-[#1e3a8a] text-sm font-medium">
                <i className="ri-checkbox-circle-line"></i>
                <span>Fully Compliant</span>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl border-2 border-[#fbbf24]/30 hover:border-[#fbbf24] hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-customer-service-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Dedicated Support</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4">
                Our customer support team is available 24/7 to assist you. Get help whenever you need it through multiple channels.
              </p>
              <div className="flex items-center gap-2 text-[#1e3a8a] text-sm font-medium">
                <i className="ri-checkbox-circle-line"></i>
                <span>24/7 Available</span>
              </div>
            </div>
          </div>

          {/* Trust Stats */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-white rounded-xl border border-[#fbbf24]/30">
              <div className="text-3xl font-bold text-[#fbbf24] mb-2">10,000+</div>
              <div className="text-sm text-gray-600">Happy Customers</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl border border-[#1e3a8a]/30">
              <div className="text-3xl font-bold text-[#1e3a8a] mb-2">99.9%</div>
              <div className="text-sm text-gray-600">Success Rate</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl border border-[#fbbf24]/30">
              <div className="text-3xl font-bold text-[#fbbf24] mb-2">&lt;5 Min</div>
              <div className="text-sm text-gray-600">Response Time</div>
            </div>
            <div className="text-center p-6 bg-white rounded-xl border border-[#1e3a8a]/30">
              <div className="text-3xl font-bold text-[#1e3a8a] mb-2">24/7</div>
              <div className="text-sm text-gray-600">Service Uptime</div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview Section */}
      <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
              Our Services
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Everything you need for your digital utility payments in one place
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-8 rounded-xl border border-gray-100 hover:border-[#fbbf24] hover:shadow-lg transition-all cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] rounded-xl flex items-center justify-center mb-6">
                <i className="ri-phone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Airtime Recharge</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                Instant airtime top-up for all Nigerian networks—MTN, Airtel, Glo, and 9mobile. Quick and reliable.
              </p>
              <div className="flex items-center text-[#1e3a8a] text-sm font-medium cursor-pointer">
                <span>Buy Now</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
            <div className="bg-white p-8 rounded-xl border border-gray-100 hover:border-[#1e3a8a] hover:shadow-lg transition-all cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-xl flex items-center justify-center mb-6">
                <i className="ri-wifi-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Data Subscription</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                Affordable data bundles for all networks. Stay connected with the best data plans at unbeatable prices.
              </p>
              <div className="flex items-center text-[#1e3a8a] text-sm font-medium cursor-pointer">
                <span>Buy Now</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
            <div className="bg-white p-8 rounded-xl border border-gray-100 hover:border-[#fbbf24] hover:shadow-lg transition-all cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] rounded-xl flex items-center justify-center mb-6">
                <i className="ri-tv-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Cable TV Payments</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                Pay for DSTV, GOTV, and Startimes subscriptions instantly. Never miss your favorite shows again.
              </p>
              <div className="flex items-center text-[#1e3a8a] text-sm font-medium cursor-pointer">
                <span>Pay Now</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
            <div className="bg-white p-8 rounded-xl border border-gray-100 hover:border-[#1e3a8a] hover:shadow-lg transition-all cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-xl flex items-center justify-center mb-6">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Electricity Bills</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                Pay your electricity bills for all DISCOs across Nigeria. Fast, easy, and convenient payment process.
              </p>
              <div className="flex items-center text-[#1e3a8a] text-sm font-medium cursor-pointer">
                <span>Pay Now</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
            <div className="bg-white p-8 rounded-xl border border-gray-100 hover:border-[#fbbf24] hover:shadow-lg transition-all cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] rounded-xl flex items-center justify-center mb-6">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Exam PINs</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                Purchase WAEC, NECO, and other exam result checker PINs instantly. Secure and reliable delivery.
              </p>
              <div className="flex items-center text-[#1e3a8a] text-sm font-medium cursor-pointer">
                <span>Buy Now</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
            <div className="bg-white p-8 rounded-xl border border-gray-100 hover:border-[#1e3a8a] hover:shadow-lg transition-all cursor-pointer">
              <div className="w-16 h-16 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-xl flex items-center justify-center mb-6">
                <i className="ri-more-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">More Services</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                Explore additional services including bulk SMS, airtime to cash, and reseller packages for businesses.
              </p>
              <div className="flex items-center text-[#1e3a8a] text-sm font-medium cursor-pointer">
                <span>Explore</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
              How It Works
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Get started in three simple steps
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 relative">
            <div className="hidden md:block absolute top-24 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-[#fbbf24]/20 via-[#fbbf24] to-[#fbbf24]/20"></div>
            
            <div className="relative text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg relative z-10">
                <span className="text-3xl font-bold text-white">1</span>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Register Your Account</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Sign up in less than 2 minutes with your phone number and email. It's quick, easy, and completely free.
              </p>
            </div>
            
            <div className="relative text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg relative z-10">
                <span className="text-3xl font-bold text-white">2</span>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Fund Your Wallet</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Add money to your wallet using bank transfer, card payment, or USSD. Multiple secure payment options available.
              </p>
            </div>
            
            <div className="relative text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-[#fbbf24] to-[#f59e0b] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg relative z-10">
                <span className="text-3xl font-bold text-white">3</span>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">Purchase Services Instantly</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Select your service, enter details, and complete your transaction in seconds. Instant delivery guaranteed.
              </p>
            </div>
          </div>
          <div className="text-center mt-12">
            <button className="px-8 py-4 text-base font-semibold text-white bg-[#fbbf24] rounded-lg hover:bg-[#f59e0b] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Get Started Now
            </button>
          </div>
        </div>
      </section>

      {/* Supported Networks Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
              Supported Networks & Providers
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We partner with all major networks and service providers across Nigeria
            </p>
          </div>

          {/* Mobile Networks */}
          <div className="mb-16">
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="h-px bg-gradient-to-r from-transparent via-[#fbbf24] to-transparent flex-1 max-w-xs"></div>
              <h3 className="text-xl font-bold text-[#1e3a8a] px-4">Mobile Networks</h3>
              <div className="h-px bg-gradient-to-r from-transparent via-[#fbbf24] to-transparent flex-1 max-w-xs"></div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="group relative bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-400">
                <div className="absolute inset-0 bg-white group-hover:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-24 h-24 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src="https://readdy.ai/api/search-image?query=mtn%20nigeria%20logo%20yellow%20black%20official%20brand%20identity%20clean%20simple%20white%20background%20telecommunications%20company&width=200&height=200&seq=mtn-logo-new-001&orientation=squarish"
                      alt="MTN Logo"
                      className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <span className="text-base font-bold text-gray-900">MTN</span>
                    <p className="text-xs text-gray-500 mt-1">Nigeria's #1 Network</p>
                  </div>
                </div>
              </div>

              <div className="group relative bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-red-400">
                <div className="absolute inset-0 bg-white group-hover:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-24 h-24 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src="https://readdy.ai/api/search-image?query=airtel%20nigeria%20logo%20red%20official%20brand%20identity%20clean%20simple%20white%20background%20telecommunications%20mobile%20network%20company&width=200&height=200&seq=airtel-logo-new-002&orientation=squarish"
                      alt="Airtel Logo"
                      className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <span className="text-base font-bold text-gray-900">Airtel</span>
                    <p className="text-xs text-gray-500 mt-1">Fast & Reliable</p>
                  </div>
                </div>
              </div>

              <div className="group relative bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-green-400">
                <div className="absolute inset-0 bg-white group-hover:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-24 h-24 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src="https://readdy.ai/api/search-image?query=glo%20nigeria%20logo%20green%20official%20brand%20identity%20clean%20simple%20white%20background%20telecommunications%20mobile%20network%20company%20globacom&width=200&height=200&seq=glo-logo-new-003&orientation=squarish"
                      alt="Glo Logo"
                      className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <span className="text-base font-bold text-gray-900">Glo</span>
                    <p className="text-xs text-gray-500 mt-1">Grandmaster of Data</p>
                  </div>
                </div>
              </div>

              <div className="group relative bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-green-400">
                <div className="absolute inset-0 bg-white group-hover:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-24 h-24 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src="https://readdy.ai/api/search-image?query=9mobile%20nigeria%20logo%20green%20official%20brand%20identity%20clean%20simple%20white%20background%20telecommunications%20mobile%20network%20company%20etisalat&width=200&height=200&seq=9mobile-logo-new-004&orientation=squarish"
                      alt="9mobile Logo"
                      className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <span className="text-base font-bold text-gray-900">9mobile</span>
                    <p className="text-xs text-gray-500 mt-1">Emerging Strong</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Cable TV Providers */}
          <div className="mb-16">
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="h-px bg-gradient-to-r from-transparent via-[#1e3a8a] to-transparent flex-1 max-w-xs"></div>
              <h3 className="text-xl font-bold text-[#1e3a8a] px-4">Cable TV Providers</h3>
              <div className="h-px bg-gradient-to-r from-transparent via-[#1e3a8a] to-transparent flex-1 max-w-xs"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="group relative bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#1e3a8a]">
                <div className="absolute inset-0 bg-gradient-to-br from-[#dbeafe] to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-32 h-20 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src="./cable TV/dstv.png"
                      alt="DSTV Logo"
                      className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <span className="text-lg font-bold text-gray-900">DSTV</span>
                    <p className="text-xs text-gray-500 mt-1">Premium Entertainment</p>
                  </div>
                </div>
              </div>

              <div className="group relative bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-red-400">
                <div className="absolute inset-0 bg-gradient-to-br from-red-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-32 h-20 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src="./cable TV/GOtv.jpg"
                      alt="GOTV Logo"
                      className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <span className="text-lg font-bold text-gray-900">GOTV</span>
                    <p className="text-xs text-gray-500 mt-1">Affordable Quality</p>
                  </div>
                </div>
              </div>

              <div className="group relative bg-white p-10 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-orange-400">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl"></div>
                <div className="relative">
                  <div className="w-32 h-20 mx-auto mb-4 flex items-center justify-center">
                    <img 
                      src="./cable TV/startimes.jpg"
                      alt="Startimes Logo"
                      className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="text-center">
                    <span className="text-lg font-bold text-gray-900">Startimes</span>
                    <p className="text-xs text-gray-500 mt-1">Value for Money</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Electricity Providers */}
          <div>
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="h-px bg-gradient-to-r from-transparent via-[#fbbf24] to-transparent flex-1 max-w-xs"></div>
              <h3 className="text-xl font-bold text-[#1e3a8a] px-4">Electricity Distribution Companies</h3>
              <div className="h-px bg-gradient-to-r from-transparent via-[#fbbf24] to-transparent flex-1 max-w-xs"></div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {[
                { name: 'KE', full: 'Kaduna Electric', seq: '009' },
                { name: 'KEDCO', full: 'Kano Electric', seq: '013' },
                { name: 'EEDC', full: 'Enugu Electric', seq: '010' },
                { name: 'EKEDC', full: 'Eko Electric', seq: '011' },
                { name: 'IBEDC', full: 'Ibadan Electric', seq: '012' },
                { name: 'APL', full: 'Aba Electric', seq: '014' },
                { name: 'JEDC', full: 'Jos Electric', seq: '015' }
              ].map((disco) => (
                <div key={disco.name} className="group relative bg-white p-6 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-[#fbbf24]">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#fef3c7] to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl"></div>
                  <div className="relative">
                    <div className="w-16 h-12 mx-auto mb-3 flex items-center justify-center">
                      <img 
                        src={`./electricity/${disco.name.toLowerCase()}.png`}
                        alt={`${disco.name} Logo`}
                        className="w-full h-full object-contain transform group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="text-center">
                      <span className="text-sm font-bold text-gray-900">{disco.name}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Trust Badge */}
          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-3 px-8 py-4 bg-[#fef3c7] rounded-full border-2 border-[#fbbf24]">
              <i className="ri-shield-check-line text-2xl text-[#1e3a8a]"></i>
              <span className="text-sm font-semibold text-[#1e3a8a]">All transactions are secure and instant</span>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#1e3a8a] to-[#1e40af]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-lg text-white/90 mb-10 leading-relaxed">
            Join thousands of Nigerians who trust IMAM BICHI DATA SUB for fast, affordable, and reliable VTU services. Create your account today and start enjoying instant transactions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="px-10 py-4 text-base font-semibold text-[#1e3a8a] bg-[#fbbf24] rounded-lg hover:bg-[#f59e0b] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Create Free Account
            </button>
            <Link 
              to="/contact"
              className="px-10 py-4 text-base font-semibold text-white bg-transparent border-2 border-white rounded-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              Contact Support
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="bg-gray-900 text-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <img 
                src="./whitelogo.png" 
                alt="IMAM BICHI DATA SUB" 
                className="h-12 w-auto object-contain mb-4"
              />
              <p className="text-sm text-gray-400 leading-relaxed">
                Your trusted partner for instant airtime, data, and bill payments in Nigeria.
              </p>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><a href="#services" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Services</a></li>
                <li><a href="#how-it-works" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">How It Works</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Pricing</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">API Documentation</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">Support</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Help Center</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Terms of Service</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Privacy Policy</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer">Refund Policy</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">Contact Us</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-[#fbbf24] mt-0.5"></i>
                  <span className="text-sm text-gray-400"><a href="tel:+2348039929272">+234 803 992 9272</a></span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-[#fbbf24] mt-0.5"></i>
                  <span className="text-sm text-gray-400">support@imambichidata.com</span>
                </li>
                <li>
                  <a 
                    href="https://wa.me/2348033838987" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-[#fbbf24] hover:bg-[#f59e0b] rounded-lg text-sm font-medium text-[#1e3a8a] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    WhatsApp Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              <p className="text-sm text-gray-400">
                © 2025 IMAM BICHI DATA SUB. All rights reserved.
              </p>
              <a 
                href="https://yusufias-porfolio.vercel.app/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-[#fbbf24] transition-colors cursor-pointer"
              >
                Developed by Yusufia Dev
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}